import { SupervisionModelEnum } from '@motivo/guanyin/src/lookup';
import useViewer from './useViewer';

export default function useSupervisionModel() {
  const { viewer } = useViewer();
  const supervisionModelId = viewer.organization.supervisionModelId;

  const isExternalAndInternal =
    supervisionModelId === SupervisionModelEnum.EXTERNAL_AND_INTERNAL;

  return {
    supervisionModelId,
    hasInternalSupervision: supervisionModelId !== SupervisionModelEnum.EXTERNAL,
    hasExternalSupervision: supervisionModelId !== SupervisionModelEnum.INTERNAL,
    isInternalOnly: supervisionModelId === SupervisionModelEnum.INTERNAL,
    isExternalOnly: supervisionModelId === SupervisionModelEnum.EXTERNAL,
    isExternalAndInternal,
    showMotivoBadge: (isInternal: boolean) => isExternalAndInternal && !isInternal,
    nonMotivoSupervisorsLabel: isExternalAndInternal ? 'non-Motivo supervisors' : 'supervisors',
  };
}
